import { z } from 'zod/v3';

// Explicit messages supplied by each schema take precedence over these defaults.
z.setErrorMap((issue) => {
  switch (issue.code) {
    case z.ZodIssueCode.invalid_type:
      return {
        message: issue.received === 'undefined' ? 'Campo obrigatório.' : 'Informe um valor válido.',
      };
    case z.ZodIssueCode.invalid_string:
      return { message: issue.validation === 'email' ? 'Email inválido.' : 'Formato inválido.' };
    case z.ZodIssueCode.too_small:
      if (issue.type === 'string')
        return { message: `Informe pelo menos ${issue.minimum} caractere(s).` };
      if (issue.type === 'number')
        return {
          message: `Informe um valor ${issue.inclusive ? 'maior ou igual a' : 'maior que'} ${issue.minimum}.`,
        };
      return { message: 'Preencha as informações obrigatórias.' };
    case z.ZodIssueCode.too_big:
      if (issue.type === 'string')
        return { message: `Informe no máximo ${issue.maximum} caractere(s).` };
      if (issue.type === 'number')
        return {
          message: `Informe um valor ${issue.inclusive ? 'menor ou igual a' : 'menor que'} ${issue.maximum}.`,
        };
      return { message: 'O valor informado excede o limite permitido.' };
    default:
      return { message: 'Verifique o valor informado.' };
  }
});
